/* tslint:disable */
/* eslint-disable */
/**
 * IRM.Web.Customer.API
 * 6d75acac-ec29-43a4-9fe0-2808f10c310c Development
 *
 * The version of the OpenAPI document: 2024.05.17.1151
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 *
 * @export
 * @interface ExportReportParams
 */
export interface ExportReportParams {
  /**
   *
   * @type {string}
   * @memberof ExportReportParams
   */
  ObjectType?: ExportReportParamsObjectTypeEnum;
  /**
   *
   * @type {Array<string>}
   * @memberof ExportReportParams
   */
  RecipientEmails?: Array<string> | null;
  /**
   *
   * @type {string}
   * @memberof ExportReportParams
   */
  Message?: string | null;
  /**
   *
   * @type {Array<string>}
   * @memberof ExportReportParams
   */
  CardCodes?: Array<string> | null;
  /**
   *
   * @type {string}
   * @memberof ExportReportParams
   */
  CreateDateStart?: string | null;
  /**
   *
   * @type {string}
   * @memberof ExportReportParams
   */
  CreateDateEnd?: string | null;
  /**
   *
   * @type {string}
   * @memberof ExportReportParams
   */
  ContractDateStart?: string | null;
  /**
   *
   * @type {string}
   * @memberof ExportReportParams
   */
  ContractDateEnd?: string | null;
  /**
   *
   * @type {string}
   * @memberof ExportReportParams
   */
  StartShipDateStart?: string | null;
  /**
   *
   * @type {string}
   * @memberof ExportReportParams
   */
  StartShipDateEnd?: string | null;
  /**
   *
   * @type {string}
   * @memberof ExportReportParams
   */
  EndShipDateStart?: string | null;
  /**
   *
   * @type {string}
   * @memberof ExportReportParams
   */
  EndShipDateEnd?: string | null;
  /**
   *
   * @type {string}
   * @memberof ExportReportParams
   */
  DocDateStart?: string | null;
  /**
   *
   * @type {string}
   * @memberof ExportReportParams
   */
  DocDateEnd?: string | null;
  /**
   *
   * @type {string}
   * @memberof ExportReportParams
   */
  DocDueDateStart?: string | null;
  /**
   *
   * @type {string}
   * @memberof ExportReportParams
   */
  DocDueDateEnd?: string | null;
  /**
   *
   * @type {string}
   * @memberof ExportReportParams
   */
  ShipDateStart?: string | null;
  /**
   *
   * @type {string}
   * @memberof ExportReportParams
   */
  ShipDateEnd?: string | null;
  /**
   *
   * @type {string}
   * @memberof ExportReportParams
   */
  SearchString?: string | null;
  /**
   *
   * @type {Array<string>}
   * @memberof ExportReportParams
   */
  ProductCodes?: Array<string> | null;
  /**
   *
   * @type {Array<string>}
   * @memberof ExportReportParams
   */
  WarehouseCodes?: Array<string> | null;
  /**
   *
   * @type {Array<string>}
   * @memberof ExportReportParams
   */
  ShipToCodes?: Array<string> | null;
  /**
   *
   * @type {Array<string>}
   * @memberof ExportReportParams
   */
  SalesTerms?: Array<string> | null;
  /**
   *
   * @type {Array<string>}
   * @memberof ExportReportParams
   */
  Modes?: Array<string> | null;
  /**
   *
   * @type {Array<string>}
   * @memberof ExportReportParams
   */
  StatusCodes?: Array<string> | null;
}

/**
 * @export
 * @enum {string}
 */
export enum ExportReportParamsObjectTypeEnum {
  None = "None",
  OBusinessPartners = "oBusinessPartners",
  OItems = "oItems",
  OInvoices = "oInvoices",
  OCreditNotes = "oCreditNotes",
  ODeliveryNotes = "oDeliveryNotes",
  OReturns = "oReturns",
  OOrders = "oOrders",
  OPurchaseInvoices = "oPurchaseInvoices",
  OPurchaseCreditNotes = "oPurchaseCreditNotes",
  OPurchaseDeliveryNotes = "oPurchaseDeliveryNotes",
  OPurchaseReturns = "oPurchaseReturns",
  OPurchaseOrders = "oPurchaseOrders",
  OQuotations = "oQuotations",
  OIncomingPayments = "oIncomingPayments",
  Deposit = "Deposit",
  OJournalEntries = "oJournalEntries",
  OVendorPayments = "oVendorPayments",
  OInventoryGenEntry = "oInventoryGenEntry",
  OInventoryGenExit = "oInventoryGenExit",
  OWarehouses = "oWarehouses",
  AtdtCorrectionInvoice = "atdtCorrectionInvoice",
  OProductionOrders = "oProductionOrders",
  ODownPayments = "oDownPayments",
  OPurchaseDownPayments = "oPurchaseDownPayments",
  InternalReconciliation = "InternalReconciliation",
  AtdtInventoryPosting = "atdtInventoryPosting",
  AtdtInventoryOpeningBalance = "atdtInventoryOpeningBalance",
  OPurchaseQuotations = "oPurchaseQuotations",
  OPurchaseQuotationGroups = "oPurchaseQuotationGroups",
  TrialBalanceFloQastReport = "TrialBalanceFloQastReport",
  TrialBalanceFloQast2Report = "TrialBalanceFloQast2Report",
  AtdtInventoryCounting = "atdtInventoryCounting",
  NotImplemented = "NotImplemented",
  CancelledReconcilliation = "CancelledReconcilliation",
  Bn = "BN",
  ClosingBalance = "ClosingBalance",
  OpeningBalance = "OpeningBalance",
}
